
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import RadioButton from '@/components/radio-button.vue';
  import PageFooter from '@/components/page-footer.vue';
  import {
    getProviderProductList,
    delProduct,
    productsampleSend
  } from '@/api/supplier';
  import {
    getExpressList,
  } from '@/api/logistics';
  import {
    handleClipboard
  } from '@/utils/clipboard';
	import {
		lookExpress,
	} from '@/api/order'
  import {
    parseTime
  } from '@/utils/index';
  import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';
  import qrCode from '@/components/qrCode.vue';

  @Component({
    name: 'product-list',
    components: {
      RadioButton,
      PageFooter,
      Message,
      'slz-dialog': Dialog,
      qrCode,

    }
  })
  export default class ProductList extends Vue {
    private productNameKey = '';
    private supplierNameKey = '';
    private productIDKey = '';
    private list: any[] = [];
    private radioType = null;
    private radioList: any = [
      {
				label: '全部',
				value: null
			},{
				label: '待初审',
				value: 0
			},{
				label: '待寄样',
				value: 3
			}, {
				label: '已寄样',
				value: 4
			}, {
				label: '待补充',
				value: 5
			} , {
				label: '待复审',
				value: 6
			} ,{
				label: '已补充',
				value: 1
			}, {
				label: '已驳回',
				value: 2
			}, 
    ];
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private showDialog = false;
    private currentDelId = 0;
    private rowmsg:any = {}
    private logisticsShow = false
    private logisticsmsg:any = {
      ProductId:'',
      ExpressId:'',
      ExpressNo:'',
    }
    private expressList:any = []
    private logisticsShow2 = false
    private logisticsmsg2:any = []

    private showcode = false
    private codemsg:any = {
      title:'扫码进入小程序',
      subtitle:'提报商品信息',
    }
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private defaultImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/9d444a0d810d7945de8af64ae2cd8a9.png'

    

    private mounted() {
      this.getProductList();
    }
    activated () {
      this.getProductList();
    }



    private toSettleFreight(row){
			this.$router.push({
				path:'settleFreight',
				query:{
					Id:row.Id,
					// ProviderId:row.ProviderId,
					Name:encodeURIComponent(row.ProductName),
					Img:encodeURIComponent(row.ImgUrlComplete || this.defaultThumb),
				}
			})
		}
    private looklogistics(row:any){
			this.rowmsg = row
			this.logisticsShow2 = true
			this.getlogistics()
		}
		private async getlogistics(){
			let res = await lookExpress({
				ExpressId:this.rowmsg.SampleSendExpressId,
				ExpressNo:this.rowmsg.SampleSendExpressNo,
				ReceivePhone:this.rowmsg.SampleSendCompanyRecipientPhone
			})
			if(res.IsSuccess){
				this.logisticsmsg2 = res.Result.sort((a,b)=>{
					return -1
				}).map((item, index)=>{
					item.color = index===0 ? '#0067cc':'#999';
					return item;
				})
			}
		}

    private async sendgoods(){
      if(!this.logisticsmsg.ExpressId){
        this.$message.error('请选择物流公司')
        return
      }else if(!this.logisticsmsg.ExpressNo){
        this.$message.error('请输入物流单号')
        return
      }
      let res:any = await productsampleSend(this.logisticsmsg)
      if(res.IsSuccess){
        this.$message.success('已提交寄样审核，审核结果将会以短信形式发送，请注意查收')
        this.close()
        this.getProductList()
      }
    }
    private close(){
      this.logisticsmsg = {
        ProductId:'',
        ExpressId:'',
        ExpressNo:'',
      }
      this.logisticsShow = false
    }
    private async togetExpressList() {
      try {
        const res: any = await getExpressList({});
        this.expressList = res.Result || [];
      } catch (e) {
        console.log(e)
      }
    }
    private Fillin(e){
      // this.rowmsg = e
      this.logisticsmsg = {
        ProductId:e.Id,
        ExpressId:'',
        ExpressNo:'',
      }
      this.logisticsShow = true
      this.togetExpressList()
    }

    private handleChange() {
      this.pageNo = 1;
      this.getProductList();
    }

    private toCreate() {
      // this.$router.push({
      //   name: 'Product_Detail',
      //   query: {
      //     type: 'new'
      //   }
      // })
      this.showcode = true
    }


    // 删除弹窗
    private handleDel(id: number) {
      this.showDialog = true;
      this.currentDelId = +id;
    }

    /**
     * 搜索
     */
    private doSearch() {
      this.pageNo = 1;
      this.getProductList();
    }

    /**
     * 清空搜索内容
     */
    private clearSearch() {
      this.productNameKey = '';
      this.supplierNameKey = '';
      this.productIDKey = '';
      // this.radioType = 0;
      this.pageNo = 1;
      this.getProductList();
    }

    /**
     * 跳转到排行榜
     */
    private toRank($event, id: number) {
      this.$router.push({
        name: 'Product_Rank',
        query: {
          id: id + ''
        }
      })
    }

    /**
     * 跳转到详情
     */
    private toDetail(event: any, id: number, state: boolean) {
      this.$router.push({
        name: state?'checkdetail':'Product_Detail',
        query: {
          type: 'edit',
          id: id + '',
          isPass: state + ''
        }
      })
    }

    /**
     * 分页器改变返回
     */
    private changeCurrent(val: number) {
      this.pageNo = val;
      this.getProductList();
    }

    /**
     * 商品列表
     */
    private async getProductList() {
      try {
        const res: any = await getProviderProductList({
          Skip: (this.pageNo-1)*this.pageSize,
          Take: this.pageSize,
          ProductCheckState: this.radioType,
          Keywords: this.productIDKey
        });
        this.total = res.Result.Total;
        this.list = res.Result.Results || [];
      } catch (e) {
        console.log('productlist ===>', e)
      }
    }

    // 复制操作
    private doCopy(event: any, data: any) {
      let status = ['未审核', '已通过', '已驳回', '已通过']
      let text = ''
      text += ('ID: ' + data.product_id + '\n')
      text += ('商品名称: ' + data.product_name + '\n')
      text += ('供应商: ' + data.provider_name + '\n')
      text += ('原价: ' + (data.discount / 100) + '\n')
      text += ('团购价: ' + (data.gp_price / 100) + '\n')
      text += ('库存: ' + (data.amount / 100) + '\n')
      text += ('状态: ' + (status[data.state]) + '\n')
      text += ('原因: ' + (data.reason || '-') + '\n')
      handleClipboard(text, event)
    }

    // 确认删除
    private async confirmDelete() {
      try {
        await delProduct({
          product_id: this.currentDelId
        })
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.showDialog = false;
        this.getProductList();
      } catch (e) {
        this.showDialog = false;
        console.log(e)
      }
    }
  }
